import api from '@/utils/httpClient';
import { PanelDropdownItemDto } from '@oncolens/oncolens-ui/lib/components/BiomarkerResults/BiomarkerResults.api';
import { useQuery, UseQueryOptions } from 'react-query';
import { biomarkerKeys } from '../Biomarkers/biomarkers.keys';

async function getPanelsByPatient(patientId: string) {
  const config: any = { containsPHI: false };
  return api.get(`/api/panels/byPatient/${patientId}`, config).then((response: any) => {
    return response.data as PanelDropdownItemDto[];
  });
}

function useGetPanelsByPatient(
  patientId: string,
  options?: UseQueryOptions<PanelDropdownItemDto[]>
) {
  return useQuery(
    biomarkerKeys.panels(patientId),
    async () => getPanelsByPatient(patientId),
    options
  );
}

export { getPanelsByPatient, useGetPanelsByPatient };
